"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeContent = void 0;
function sanitizeContent(content) {
    if (!content)
        return String();
    return content
        .replace(/>[\t\n\s]+<(?!\/(?:tspan|text))/g, '><')
        .replace(/a>[\t\n\s]+<(\/tspan)/g, 'a><')
        .replace(/<\/tspan>\s*/g, '</tspan>')
        .replace(/\s*<tspan/g, '<tspan')
        .replace(/<\/text>\s*/g, '</text>')
        .replace(/\s*<text/g, '<text')
        .replace(/<\/g>\s*/g, '</g>')
        .replace(/<\/svg>\s*/g, '</svg>')
        .trim();
}
exports.sanitizeContent = sanitizeContent;
//# sourceMappingURL=sanitize.js.map